/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flaky_Vexed_Polecat_BurnInputs */

const en_flaky_vexed_polecat_burn = /** @type {(inputs: Flaky_Vexed_Polecat_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No promoters`)
};

const de_flaky_vexed_polecat_burn = /** @type {(inputs: Flaky_Vexed_Polecat_BurnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Promotoren`)
};

/**
* | output |
* | --- |
* | "No promoters" |
*
* @param {Flaky_Vexed_Polecat_BurnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flaky_vexed_polecat_burn = /** @type {((inputs?: Flaky_Vexed_Polecat_BurnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flaky_Vexed_Polecat_BurnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flaky_vexed_polecat_burn(inputs)
	return de_flaky_vexed_polecat_burn(inputs)
});